import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatSliderModule } from '@angular/material/slider';
import { LayoutModule } from '@angular/cdk/layout';
import { WizardComponent } from './wizard/wizard.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatChipsModule } from '@angular/material/chips';
import {
  TranslocoConfig,
  TranslocoModule,
  TRANSLOCO_CONFIG,
} from '@ngneat/transloco';
import { httpLoader } from './core/services/http-loader';
import { CompleteComponent } from './complete/complete.component';
import { WINDOW_PROVIDERS } from './core/window.provider';
import {
  APP_BASE_HREF,
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
} from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { createCustomElement } from '@angular/elements';
import { MatSelectModule } from '@angular/material/select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { StoreModule } from '@ngrx/store';
import { mydocReducer } from './redux/mydoc.reducer';
import { MY_DOC_FEATURE_KEY } from './redux/mydoc.selector';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LanguageSelectionComponent } from './wizard/export/components/language/language-selection.component';
import { ExportStructureComponent } from './wizard/export/components/export-structure/export-structure.component';
import { CustomizeToggleComponent } from './wizard/export/components/customize-toggle/customize-toggle.component';
import { TooltipOverlayComponent } from './wizard/export/components/tooltip-overlay/tooltip-overlay.component';
import { FolderStructureComponent } from './wizard/export/components/folder-structure/folder-structure.component';
import { EffectsModule } from '@ngrx/effects';
import { MydocEffects } from './redux/mydoc.effects';
import { FileStructureComponent } from './wizard/export/components/file-structure/file-structure.component';
import { environment } from '../environments/environment';

@NgModule({ declarations: [
        WizardComponent,
        AppComponent,
        CompleteComponent,
        LanguageSelectionComponent,
        ExportStructureComponent,
        CustomizeToggleComponent,
        TooltipOverlayComponent,
        FolderStructureComponent,
        FileStructureComponent,
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSliderModule,
        MatIconModule,
        MatStepperModule,
        MatInputModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatCardModule,
        LayoutModule,
        MatCheckboxModule,
        SharedModule,
        CoreModule,
        TranslocoModule,
        MatSelectModule,
        MatChipsModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        MatTooltipModule,
        NgMultiSelectDropDownModule.forRoot(),
        StoreModule.forRoot({ [MY_DOC_FEATURE_KEY]: mydocReducer }),
        EffectsModule.forRoot([MydocEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
        })], providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        httpLoader,
        WINDOW_PROVIDERS,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: TRANSLOCO_CONFIG,
            useValue: {
                availableLangs: [
                    'en',
                    'de',
                    'cs',
                    'da',
                    'es',
                    'fi',
                    'fr',
                    'hr',
                    'hu',
                    'it',
                    'ja',
                    'ko',
                    'nl',
                    'no',
                    'po',
                    'pt',
                    'ro',
                    'ru',
                    'sl',
                    'sv',
                    'tr',
                    'vi',
                    'zh',
                ],
                reRenderOnLangChange: true,
                fallbackLang: 'en',
            } as TranslocoConfig,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule implements DoBootstrap {
  constructor(
    private injector: Injector,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIconResolver(
      (name: string, namespace: string) => {
        return namespace === ''
          ? domSanitizer.bypassSecurityTrustResourceUrl(
              environment.iconUrl + `${name}.svg`
            )
          : null;
      }
    );
  }

  public ngDoBootstrap(): void {
    if (!customElements.get('mydocuments-root')) {
      const counterDisplay = createCustomElement(AppComponent, {
        injector: this.injector,
      });
      customElements.define('mydocuments-root', counterDisplay);
    }
  }
}
